export default () => {
  return {
    content: {
      visit_identifier: '',
      assessment_platform: 'both',
    },
  };
};
